var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "prelative" },
    [
      _vm.currentLabel
        ? _c("avatar-randomized", {
            staticClass: "pabsolute zi-1 select-input-avatar-randomized",
            attrs: {
              firstname: "",
              lastname: _vm.currentLabel,
              size: "extra-small"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.mode == "edit"
        ? _c(
            "el-select",
            {
              staticClass: "wp-10",
              attrs: {
                placeholder: _vm.placeholder,
                value: _vm.value,
                filterable: _vm.filterable,
                disabled: _vm.disabled,
                multiple: _vm.multiple,
                size: _vm.size,
                "popper-append-to-body": false,
                "popper-class": "custom-dropdown"
              },
              on: { change: _vm.update }
            },
            [
              _vm.selectNothing
                ? _c("el-option", {
                    attrs: { label: _vm.selectNothing, value: null }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.options, function(option) {
                return _c(
                  "el-option",
                  {
                    key: option[_vm.idColumn],
                    attrs: {
                      label: option[_vm.labelColumn],
                      value: option[_vm.idColumn],
                      disabled: !!option.disabled
                    }
                  },
                  [
                    _vm.displayAvatar && _vm.displayAvatar.onOptions
                      ? _c("avatar-randomized", {
                          staticClass: "mr-1",
                          attrs: {
                            firstname: "",
                            lastname: option.label,
                            size: "extra-small"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._t(
                      "default",
                      [_vm._v(_vm._s(option[_vm.labelColumn]))],
                      { option: option }
                    )
                  ],
                  2
                )
              })
            ],
            2
          )
        : _c("p", [
            _vm._v("\n        " + _vm._s(_vm.labelFromValue) + "\n    ")
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }